const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const firebaseVapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export function isFirebaseConfigured() {
	return Boolean(
		firebaseConfig.apiKey &&
			firebaseConfig.projectId &&
			firebaseConfig.messagingSenderId &&
			firebaseConfig.appId &&
			firebaseVapidKey,
	);
}

export default firebaseConfig;
